import { subscriptionTypesMap } from '@/data/type-maps';

export default {
  beforeMount(el, binding) {
    const context = binding.instance;
    if (context.$user && context.$user?.permissions?.subscription?.tag === subscriptionTypesMap.free ||
      (binding?.arg === 'waybill' && context.$user?.permissions?.subscription.tag === subscriptionTypesMap.mini)) {
      el.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
      });

      if (el.firstChild) {
        el.firstChild.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
        });
      }

      el.setAttribute('disabled', 'disabled');
    }
  },
};
